/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService
 */

export const getRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'get',
  auth: 'app',
  fingerprint: '902ySleQCngXBEydlghfZANaOMGUZfsO'
};
export const getPlaylistOrLearningPathRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'getPlaylistOrLearningPath',
  auth: 'app',
  fingerprint: '902ySleQCniyahNaCgAOMANaOMGUZfsO'
};
export const getAllPaginatedRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'getAllPaginated',
  auth: 'app',
  fingerprint: '5wAjhr_5tnwsMeouDwl9ngNaOMGUZfsO'
};
export const getLearningPathsRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'getLearningPaths',
  auth: 'app',
  fingerprint: 'G2qJKgEVkS8sGdvQM2YEQANaOMGUZfsO'
};
export const getSimpleLearningPathsOrPlaylistsRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'getSimpleLearningPathsOrPlaylists',
  auth: 'app',
  fingerprint: 'VpwY3Z8oCPc-5rp_yR72zgNaOMGUZfsO'
};
export const getAllPaginatedInternalRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'getAllPaginatedInternal',
  auth: 'app',
  fingerprint: '5wAjhr_5tnwsMeouDwl9ngNaOMGUZfsO'
};
export const createRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'KaTwacI-hU4XBEydlghfZANaOMGUZfsO'
};
export const createFromPlaylistRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'createFromPlaylist',
  auth: 'app',
  fingerprint: 'aiu_ihVtOK4XBEydlghfZANaOMGUZfsO'
};
export const updateRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'update',
  auth: 'app',
  fingerprint: '_gotTWK8DNkXBEydlghfZANaOMGUZfsO'
};
export const deleteRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: '360j63y7xP8DFLtas3o9fQNaOMGUZfsO'
};